import { configureStore } from '@reduxjs/toolkit';

import rootReducer from './rootReducer';
import { localStorageMiddleware } from './tags-view.store';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(localStorageMiddleware),
});

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

export default store;

export type AppStore = typeof store;
